// An enum to track message state in terms of user's action
const MessageStatus = {
    Unread: 0,
    Read: 1,
    Closed: 2
};
export default MessageStatus;
